/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Minnotexceedmax7Inputs */

const en_coinvestments_gpestimatedticketsize_modal_minnotexceedmax7 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Minnotexceedmax7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum must not exceed Maximum`)
};

/**
* | output |
* | --- |
* | "Minimum must not exceed Maximum" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Minnotexceedmax7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_minnotexceedmax7 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Minnotexceedmax7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Minnotexceedmax7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_minnotexceedmax7(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_minnotexceedmax7 as "coInvestments_gpEstimatedTicketSize_modal_minNotExceedMax" }